import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FolderDTO } from '../../types/apiType';

export interface FolderState {
  myFolders: FolderDTO[];
  selectedFolder: FolderDTO | null;
}

const initialState: FolderState = {
  myFolders: [],
  selectedFolder: null,
};

export const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    setFolderList: (state, action: PayloadAction<FolderDTO[]>) => {
      state.myFolders = action.payload;
    },
    setSelectedFolder: (state, action: PayloadAction<FolderDTO | null>) => {
      state.selectedFolder = action.payload;
    },
  },
});

export const { setFolderList, setSelectedFolder } = folderSlice.actions;

export default folderSlice.reducer;
